import React from "react";
import Preloader from "../../Global/Preloader";
import Headertwo from "../../Global/Headertwo";
import Innerpage from "../../Portfolio/MenPortfolioDeatails/Innerpage";
import Details from "../MenPortfolioDeatails/Details";
import Portfolio from "../MenPortfolioDeatails/Portfolio";
import Ctaone from "../../Global/Ctaone";
import Footer from "../../Global/Footer";
import BackToTop from '../../Global/BackToTop';
import Servicedtlbred from '../../Services/Mainservicesdetails/Servicedtlbred';
import Testimonialone from '../../Home/Mainhomeone/Testimonialone';

const Main = () => {
    return(
        <>
        {/* <Preloader/> */}
          <Headertwo/>
          <Servicedtlbred title="Testimonials" />
          <Testimonialone/>
          {/* <Innerpage/> */}
          {/* <Details/>
          <Portfolio/>
          <Ctaone/> */}
          <Footer/>
          <BackToTop/>
        </>
    )
}
export default Main;